var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mq-layout',{staticClass:"flex flex-wrap px-4",class:{
      'justify-center': _vm.vaults.length == 1,
      'justify-start': _vm.vaults.length >= 2,
    },attrs:{"mq":"tablet+"}},_vm._l((_vm.vaults),function(vault,index){return _c('vault-rectangle',{key:index,ref:'vault_' + index,refInFor:true,attrs:{"vault":vault,"stats":_vm.getCurrentVaultStats(vault.id)}})}),1),_vm._v(" "),_c('mq-layout',{staticClass:"flex flex-wrap px-4",class:{
      'justify-center': _vm.vaults.length == 1,
      'justify-start': _vm.vaults.length >= 2,
    },attrs:{"mq":"mobile"}},_vm._l((_vm.vaults),function(vault,index){return _c('vault-box',{key:index,ref:'vault_' + index,refInFor:true,attrs:{"vault":vault,"stats":_vm.getCurrentVaultStats(vault.id)}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }